import script from "./PottingView.vue?vue&type=script&setup=true&lang=js"
export * from "./PottingView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__